export const DefaultRoleMockData = [
  {
    id: '2c01b4d4-8aa6-eb11-94b3-000d3a223666',
    name: 'MockDefaultRoleName',
    partnersOnly: false,
    selector: 'MockDefaultSelector',
    addToScopeTypeCreator: 'MockDefaultScopeSelector',
    permissions: [
      {
        permissionId: '7526435d-b51b-4141-91bb-e6a8310bf1e0',
        name: 'ManageDrillholeInfo',
        selector: 'Drillhole',
      },
      {
        permissionId: 'bf6d986d-32ac-4764-8d5e-5489467e7075',
        name: 'ViewDrillholeData',
        selector: 'Drillhole',
      },
    ],
  },
] as any[];
